import { render } from "./FrostwarningIcon.vue?vue&type=template&id=b9af7a2c"
import script from "./FrostwarningIcon.vue?vue&type=script&lang=js"
export * from "./FrostwarningIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__